function enterNode() {
    const {
        commands: {canGrowNode, growNode},
        selectedNodes,
    } = this

    if (0 === selectedNodes.size) {
        return
    }

    const node = [...selectedNodes].at(-1)

    if (node.firstChild) {
        this.commands.moveRightSelection()
    }
    else {
        const nodes = canGrowNode([node])

        if (0 < nodes.length) {
            growNode(nodes, false)
        }
    }
}

export default {
    'ArrowRight': enterNode,
}
